function HpFooter() {
  return (
    <footer className="hp-footer">
      <img src="/tl237rrtlogo.png" alt="RRT" className="hp-footer-logo" />
      <p className="hp-footer-copyright">
        COPYRIGHT &copy; 2023 YOUNG LAW GROUP | <a href="/privacy-policy">PRIVACY POLICY</a> | <a href="/terms">TERMS AND CONDITIONS</a>
      </p>
      <p className="hp-footer-disclaimer">
        The Rapid Response Team is a worker safety platform operated by Pond Lehocky Giordano, Inc., and Young Law Group, P.C. YLG has
        established the Rapid Response Team to provide urgent legal and investigative assistance for workplace
        incidents. Maintaining strict confidentiality, YLG advises that website information and preliminary
        interactions do not constitute an attorney-client relationship, which requires a formal agreement. For
        more details, please see our <a href="/disclaimer">DISCLAIMER</a>.
      </p>
    </footer>
  );
}

export default HpFooter;
